import React from 'react';

import Quicks from '../components/quicks';

const Component = () => {
    return (
        <div>
            <Quicks
                external
                links={[]}
                navs={[
                    { name: 'PLANR Lab', link: '#Lab' },
                    { name: 'Research', link: '#Research' },
                    { name: 'Facilities', link: '#Facilities' }
                ]}
            />

            <h3>Page Under Construction</h3>
        </div>
    );
};

export default Component;
